/* eslint-disable import/prefer-default-export */
import {
  Field, Form, defineRule, configure,
} from 'vee-validate';
import {
  required, email, confirmed, length, numeric, min_value, max,
} from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
/**
  *
  * @param {import('vue').App} Vue
  */
export function installVeeValidate(Vue) {
  // Vue.component('ValidationProvider', ValidationProvider);
  // Vue.component('ValidationObserver', ValidationObserver);
  Vue.component('VForm', Form);
  Vue.component('VField', Field);

  // setInteractionMode('custom', ({ errors }) => {
  //   if (errors.length) {
  //     return {
  //       on: ['input', 'change'],
  //     };
  //   }
  //   return {
  //     on: ['change'],
  //   };
  // });

  defineRule('required', required);
  defineRule('email', email);
  defineRule('confirmed', confirmed);
  defineRule('length', length);
  defineRule('numeric', numeric);
  defineRule('min_value', min_value);
  defineRule('max', max);

  configure({
    generateMessage: localize('en', {
      messages: {
        required: '{field} is required',
        email: 'This field must be a valid email',
        confirmed: '{field} confirmation does not match',
        length: '{field} must have 2 options',
        numeric: '{field} only supports numbers',
        min_value: (ctx) => `The value must be higher than ${ctx.rule.params[0]}`,
      },
    }),
  });

  // extend('required', {
  //   ...required,
  //   message: '{_field_} is required',
  // });

  // extend('email', {
  //   ...email,
  //   message: 'This field must be a valid email',
  // });

  // extend('confirmed', {
  //   ...confirmed,
  //   message: '{_field_} confirmation does not match',
  // });

  // extend('length', {
  //   ...length,
  //   message: '{_field_} must have 2 options',
  // });

  // extend('numeric', {
  //   ...numeric,
  //   message: '{_field_} only supports numbers',
  // });

  // extend('min_value', {
  //   ...min_value,
  //   message: 'The value must be higher than {min}',
  // });
}